import { ContactClassificationStatus } from '@/models/ContactClassificationStatus';

/**
 * A supported's classification as returned by the management view - the name and the fields needed
 * to derive its expiration state, without documents and history.
 */
export interface ManagementSupportedClassificationDtoIn {
  id: number;
  name: string;
  fundId: number;
  status: ContactClassificationStatus;
  expiresTimestamp: string | null;
  requestedAt: string;
  approvedAt: string | null;
}

/**
 * DTO for supported in management view.
 */
export interface ManagementSupportedDtoIn {
  id: number;
  firstName: string;
  lastName: string;
  israeliId: string;
  email?: string;
  phone?: string;
  paymentInfosCount: number;
  childrenCount: number;
  fundIds: number[];
  contactClassifications: ManagementSupportedClassificationDtoIn[];
}

/**
 * Query parameters for supporteds request.
 */
export interface SupportedsQueryParams {
  sortBy: string;
  sortDirection: 'Asc' | 'Desc';
  searchTerm?: string;
  fundId?: number;
  /** Classification names to filter by, or NO_CLASSIFICATION for supporteds with none. */
  classificationFilters?: string[];
  /** PendingApproval, Expired or ExpiringSoon. Undefined means no filtering. */
  expirationFilter?: string;
  /** Only supporteds with a coordinator's request to correct their ID waiting for the office (HAT-1428). */
  onlyPendingIsraeliIdChangeRequests?: boolean;
}

/** The classification filter key for supporteds with no classification at all. */
export const NO_CLASSIFICATION = 'NO_CLASSIFICATION';

/**
 * The outcome of removing a supported from a fund.
 */
export interface RemoveSupportedFromFundResult {
  /** True when that was the supported's last fund, so the supported itself was deleted (archived). */
  supportedArchived: boolean;
}
